const editFormModalWithTextInputFlags = {
    save: 'ZAPISZ ZMIANY',
    cancel: 'ANULUJ ZMIANY'
};

export default editFormModalWithTextInputFlags;